import PageTemplate from '../components/common/PageTemplate';
import CategoryList from '../screen/category/CategoryList';

const CategoryListPage = () => {
  return (
    <PageTemplate
      mainComponent={<CategoryList />}
      noPadding={true}
      logo="Kategori"
    />
  );
}

export default CategoryListPage
